export function polygonToPoints({ sides, radius, rotation = -Math.PI / 2 }) {
  const pts = [];

  for (let i = 0; i < sides; i++) {
    const angle = rotation + (i * 2 * Math.PI) / sides;

    pts.push(
      radius * Math.cos(angle),
      radius * Math.sin(angle)
    );
  }

  return pts;
}

export function arrowToPolygonPoints({
  length = 160,
  shaftWidth = 20,
  headLength = 40,
  headWidth = 40
}) {
  const halfShaft = shaftWidth / 2;
  const halfHead = headWidth / 2;
  const shaftEnd = length - headLength;
  const cx = length / 2;

  return [
    -cx, -halfShaft,
    shaftEnd - cx, -halfShaft,

    shaftEnd - cx, -halfHead,
    length - cx, 0,

    shaftEnd - cx, halfHead,
    shaftEnd - cx, halfShaft,

    -cx, halfShaft
  ];
}

export function scalePointsToIcon(points, size = 40, padding = 4) {
  const xs = [];
  const ys = [];

  for (let i = 0; i < points.length; i += 2) {
    xs.push(points[i]);
    ys.push(points[i + 1]);
  }

  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  const width = maxX - minX;
  const height = maxY - minY;

  const scale = Math.min(
    (size - padding * 2) / width,
    (size - padding * 2) / height
  );

  const offsetX = (size - width * scale) / 2;
  const offsetY = (size - height * scale) / 2;

  const result = [];

  for (let i = 0; i < points.length; i += 2) {
    result.push(
      (points[i] - minX) * scale + offsetX,
      (points[i + 1] - minY) * scale + offsetY
    );
  }

  return result.join(' ');
}

export function circleToPolygonPoints({ radius = 50, segments = 32 } = {}) {
  const r = Number(radius);
  const n = Math.max(3, Number(segments) || 32);

  if (!Number.isFinite(r) || r <= 0) return [];

  const pts = [];
  const rot = -Math.PI / 2;
  for (let i = 0; i < n; i++) {
    const a = rot + (i * 2 * Math.PI) / n;
    pts.push(r * Math.cos(a), r * Math.sin(a));
  }
  return pts;
}

export function regularPolygonPoints(sides = 6, radius = 60) {
  const pts = [];
  for (let i = 0; i < sides; i++) {
    const a = (i / sides) * Math.PI * 2 - Math.PI / 2;
    pts.push(Math.cos(a) * radius);
    pts.push(Math.sin(a) * radius);
  }
  return pts;
}

export function starToPolygonPoints({
  numPoints = 5,
  innerRadius = 20,
  outerRadius = 50,
  rotation = -Math.PI / 2,
}) {
  const pts = [];
  const step = Math.PI / numPoints;

  for (let i = 0; i < numPoints * 2; i++) {
    const radius = i % 2 === 0 ? outerRadius : innerRadius;
    const angle = rotation + i * step;

    pts.push(
      Math.cos(angle) * radius,
      Math.sin(angle) * radius
    );
  }

  return pts;
}

export function ellipseToPolygonPoints({
  radiusX,
  radiusY,
  segments = 32,
}) {
  const pts = [];

  for (let i = 0; i < segments; i++) {
    const angle = (i / segments) * Math.PI * 2;

    pts.push(
      Math.cos(angle) * radiusX,
      Math.sin(angle) * radiusY
    );
  }

  return pts;
}
